const initHeroAnimations = () => {
  const hero = document.querySelector('[data-module="hero-animations"]')

  if (! hero) {
    return
  }

  const reveal = () => {
    window.requestAnimationFrame(() => {
      hero.classList.add('is-ready')
    })
  }

  if (document.querySelector('[data-loader]')) {
    document.addEventListener('worthouse:loader-done', reveal, { once: true })
    return
  }

  reveal()
}

export default initHeroAnimations



// WEBPACK FOOTER //
// ./resources/assets/js/components/hero-animations.js